import { render } from "./flight-edit.vue?vue&type=template&id=1542d505"
import script from "./flight-edit.vue?vue&type=script&lang=js"
export * from "./flight-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__